module.exports = "/_next/static/images/coffee-03c8b5f5c78e7a0d3da5a4b0c9dddc72.png";